import "./Loader.scss";
import PropTypes from "prop-types";

const Loader = ({ children }) => {
	return (
		<section className="loader-overlay">
			<output className="spinner-border"></output>
			{children}
		</section>
	);
};
Loader.propTypes = {
	children: PropTypes.node,
};

export default Loader;
